@use '@/styles/variables' as *;

.button {
    width: 100%;
    max-width: 283px;
    height: 42px;
    border-radius: $borderRadius * 2;
    border: 1px solid transparent;
    background-color: transparent;
    color: $white;
    cursor: pointer;
    font-size: 16px;
    line-height: 120%;
    position: relative;
    padding: 0 20px;
    outline: none;

    &:hover {
        &:not(:disabled):not(.loading) {
            opacity: $opacityOnHover;
        }
    }

    &:disabled {
        background-color: $accent;
        opacity: 50%;
        color: $white;
    }

    &.loading {
        opacity: 0.45;
    }

    &.hasIcon {
        padding-left: 44px;
    }


}

.icon {
    position: absolute;
    width: 30px;
    height: 100%;
    left: 8px;
    top: 0;

    svg {
        width: 22px;
        height: 22px;
        color: $white;
    }
}

.accent,
.accentSmall {
    background-color: $accent;

    &:hover {
        &:not(:disabled):not(.loading) {
            opacity: 1;
            background-color: $accentOnHover;
        }
    }
}

.outline,
.outlineSmall {
    background-color: $white;
    border: 1px solid $accent;
    color: $accent;
}

.accentSmall,
.outlineSmall {
    height: 28px;
    border-radius: $borderRadius;
}

.link {
    height: fit-content;
    width: fit-content;
    border-radius: 0;
    box-shadow: none;
    background-color: transparent;
    color: $accent;
    text-decoration: underline;
}

.sq {
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    padding: 0;
    border-radius: 0;

    svg {
        width: 18px;
        height: 18px;
    }
}

.spinnerWrapper {
    position: absolute;
    top: 50%;
    left: 16px;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
}
